import { ResponsiveImage } from './responsive-image';
import {
  getCellVisibillityClasses,
  getCellVisibilityStatus,
  type ResponsiveSources,
} from './power-cell-getters';

/**
 * The overlay box sits exactly on the cell image and clips its content.
 */
export const imageOverlayClipClasses: string =
  'absolute z-[3] aspect-cell-image w-full overflow-hidden';

/**
 * The overlay image bleeds 1px past every edge of the clip box. Safari draws a
 * scaled image overlay with soft, partly transparent edges, which shows the cell
 * image through as a thin line; the bleed keeps those edges outside the clip.
 */
export const imageOverlayBleedClasses: string =
  'absolute -left-px -top-px h-[calc(100%+2px)] w-[calc(100%+2px)] max-w-none object-cover';

/**
 * Builds the clip box classes, hiding the box on breakpoints without an overlay
 * @param imageSources - Overlay image sources for each breakpoint
 * @returns Class names for the overlay clip box
 */
export function getImageOverlayClipClasses(
  imageSources: ResponsiveSources
): string {
  return getCellVisibillityClasses(imageSources, imageOverlayClipClasses);
}

/**
 * Renders the cell image overlay on top of the cell image
 * @param imageSources - Overlay image sources for each breakpoint
 * @param altText - Alt text for the overlay image
 * @returns JSX.Element with the clipped overlay image
 */
export function ImageOverlay({
  imageSources,
  altText,
}: {
  imageSources: ResponsiveSources;
  altText: string;
}): JSX.Element {
  if (!getCellVisibilityStatus(imageSources)) return <></>;

  return (
    <div className={getImageOverlayClipClasses(imageSources)}>
      <ResponsiveImage
        imageSources={imageSources}
        altText={altText}
        classNames={imageOverlayBleedClasses}
      />
    </div>
  );
}
